export const CLIENT_INVITES_SYNC = 'CLIENT_INVITES_SYNC';
export const ACCEPT_INVITE = 'ACCEPT_INVITE';
export const DISMISS_INVITE = 'DISMISS_INVITE';
export const DISMISS_INVITE_SUCCESS = 'DISMISS_INVITE_SUCCESS';
export const CLIENT_ACCEPT_INVITE_RESULT = 'CLIENT_ACCEPT_INVITE_RESULT';
export const CLIENT_ACCEPT_INVITE_RESULT_CLEAR = 'CLIENT_ACCEPT_INVITE_RESULT_CLEAR';
export const CLIENT_AUTHCODE_REDIRECT = 'CLIENT_AUTHCODE_REDIRECT';

// User Profile Actions
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS';
export const UPDATE_USER_PROFILE_FAILURE = 'UPDATE_USER_PROFILE_FAILURE';
export const CHANGE_USER_PASSWORD = 'CHANGE_USER_PASSWORD';
export const CHANGE_USER_PASSWORD_SUCCESS = 'CHANGE_USER_PASSWORD_SUCCESS';
export const CHANGE_USER_PASSWORD_FAILURE = 'CHANGE_USER_PASSWORD_FAILURE';

export const FETCH_USER_ROLES = 'FETCH_USER_ROLES';
export const USER_ROLES_LOADED = 'USER_ROLES_LOADED';
